exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(true);
// Module
exports.push([module.id, ".style__container--bECM_ {\n  -webkit-user-select: none;\n     -moz-user-select: none;\n      -ms-user-select: none;\n          user-select: none; }\n", "",{"version":3,"sources":["/Users/diegomartin/Documents/GitHub/dashboard/src/components/ToggleLink/style.scss"],"names":[],"mappings":"AAAA;EACI,yBAAiB;KAAjB,sBAAiB;MAAjB,qBAAiB;UAAjB,iBAAiB,EAAA","file":"style.scss","sourcesContent":[".container {\n    user-select: none;\n}"],"sourceRoot":""}]);

// Exports
exports.locals = {
	"container": "style__container--bECM_"
};